import {
    ChangeDetectionStrategy,
    Component,
    computed,
    input,
    model,
    ViewEncapsulation,
} from "@angular/core";
import { CerrixAvatarComponent } from "@app/shared/atoms/cerrix-avatar/cerrix-avatar.component";

/** Structurally the same option shape as app-cerrix-select, so callers can feed both from one array. */
export interface CerrixSelectListOption {
    label: string;
    value: string;

    /** Renders an avatar for this person in front of the label. Omitted when the option isn't a person. */
    avatarName?: string;
}

@Component({
    selector: "app-cerrix-select-list",
    imports: [CerrixAvatarComponent],
    templateUrl: "./cerrix-select-list.component.html",
    styleUrl: "./cerrix-select-list.component.scss",
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CerrixSelectListComponent {
    readonly options = input.required<CerrixSelectListOption[]>();
    readonly emptyText = input("No items");

    /** With multiselect off, picking an option drops whatever was picked before. */
    readonly multiselect = input(false);

    /** Prefix of the data-uiid of each option, which ends in the option value. No prefix, no data-uiid. */
    readonly dataUiid = input<string>();
    readonly readonly = input(false);

    readonly selectedValues = model<string[]>([]);

    private readonly selectedValueSet = computed(() => new Set(this.selectedValues()));

    protected isSelected(option: CerrixSelectListOption): boolean {
        return this.selectedValueSet().has(option.value);
    }

    protected toggle(option: CerrixSelectListOption): void {
        if (this.readonly()) {
            return;
        }

        this.selectedValues.update((values) => {
            if (values.includes(option.value)) {
                return values.filter((value) => value !== option.value);
            }

            return this.multiselect() ? [...values, option.value] : [option.value];
        });
    }
}
